<template>
	<div class="kunye-page">
		<div style="display: flex;flex-direction: row; justify-content: center; text-align: right;">
			<div style="display: flex;flex-direction: column; width: 590px;">
				<router-link :to="{name:'paratoner'}" class="kunye-item kunye-item-left">
					<div class="work-name">Boş Zırh</div>
					<div class="work-description">Krom yıldırımlık, bakır kablo</div>
				</router-link>
				<router-link :to="{name:'yaprak'}" class="kunye-item kunye-item-left">
					<div class="work-name">Ölü Adamın Çelengi</div>
					<div class="work-description">Lazer kesilmiş PP üzerine UV baskı</div>
				</router-link>
				<router-link :to="{name:'dal'}" class="kunye-item kunye-item-left">
					<div class="work-name">Ağızlık</div>
					<div class="work-description">Kabuk böceği feromonu, çatal, polyester</div>
				</router-link>
				<router-link :to="{name:'kazima'}" class="kunye-item kunye-item-left">
					<div class="work-name">Gökyüzünden Buruk <br> Bir Yarık İniyor</div>
					<div class="work-description">Akasya ağacı üzerine oyma</div>
				</router-link>
				<router-link :to="{name:'madalyon'}" class="kunye-item kunye-item-left">
					<div class="work-name">Bütün Beyazı İçtim,<br> Kemiklerimi <br>Hissetmiyorum</div>
					<div class="work-description">Gümüş döküm madalyon, timsah ağzı, bakır topraklama çubuğu</div>
				</router-link>
			</div>
			<hr id="vert-rule">
			<div style="display: flex;flex-direction: column;font-style: oblique; text-align: left;width: 590px;">
				<router-link :to="{name:'paratoner'}" class="kunye-item kunye-item-right">
					<div class="work-name">Empty Armor</div>
					<div class="work-description">Chrome lightning rod, copper wire</div>
				</router-link>
				<router-link :to="{name:'yaprak'}" class="kunye-item kunye-item-right">
					<div class="work-name">Dead Man's Wreath</div>
					<div class="work-description">UV Print on Laser cut PP</div>
				</router-link>
				<router-link :to="{name:'dal'}" class="kunye-item kunye-item-right">
					<div class="work-name">Muzzle</div>
					<div class="work-description">Scolytinae pheromones, fork, polyester</div>
				</router-link>
				<router-link :to="{name:'kazima'}" class="kunye-item kunye-item-right">
					<div class="work-name">An Acrid Slit Comes <br>Down From the Sky</div>
					<div class="work-description">Engraving on acacia tree</div>
				</router-link>
				<router-link :to="{name:'madalyon'}" class="kunye-item kunye-item-right">
					<div class="work-name">I Drank All White,<br> I Don't Feel <br>My Bones</div>
					<div class="work-description">Silver casting locket, alligator clips, copper grounding rod</div>
				</router-link>
			</div>
		</div>
		<img src="/images/it-flashed.png" style="width: 100%; margin-top: 40px;">
		<div style="margin-top: 10px;font-family: hk-grotesk-boldlegacy;color: #00ff19;">Cem Örgen, 2019</div>
		<div style="display: flex;justify-content: space-evenly;align-items: center;color: #00ff19;margin-top: 200px;">
			<div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
				<img src="/images/sub-logo.png" alt="" style="width: 260px;">
				<div style="display: flex;flex-direction: row;justify-content: center;font-family: hk-grotesk-semibold;padding-top: 20px; font-size: 12px;">
					<div>tarafından desteklendi</div>
					<hr id="vert-rule-3" style="margin: 0px 31px; color:#00ff19 ;">
					<div>supported by</div>
				</div>
			</div>
			<div style="text-align: center;justify-content: center;">
				<div style="display: flex;flex-direction: row; justify-content: center;font-family: hk-grotesk-boldlegacy; font-size: 20px; margin-bottom: 10px;">
					<div>Teşekkürler</div>
					<hr id="vert-rule-2" style="color: #00ff19; margin: 0px 5px;">
					<div style="font-style: oblique">Thanks To</div>
				</div>
				<div style="display: flex;flex-direction: row;width: 300px;font-family: hk-grotesk-semibold;font-style: oblique">
					Baran Elitez, Burakhan Viltan, Can Küçük, Kıvılcım Güngörün, Selver Yıldırım
				</div>
			</div>
		</div>

		<a href="https://www.twitch.tv/itflashediturnedaway/clips?filter=clips&range=all" target="_blank" class="stream-link vert-rule" style="font-family: hk-grotesk-boldlegacy">
			<div>Yayın</div>
			<hr class="vert-rule" style="border-color: red;margin: 0px 5px;">
			<div style="font-style: oblique;">Stream</div>
		</a>
	</div>

</template>

<script>
	import $ from 'jquery'

	export default {
		name: "KunyePage",
		mounted() {
			// var turkishItems = document.getElementsByClassName('kunye-item-left')
			// var englishItems = document.getElementsByClassName('kunye-item-right')
			//
			// for (const turkishItem of turkishItems) {
			// 	turkishItem.onmouseover = console.log("AY")
			// }

			$('.kunye-item-left').on("mouseover", function () {
				var indexTarget = $(this).index()
				// $('.kunye-item-right').addClass('color-black-modifier')
				$('.kunye-item-right').eq(indexTarget).addClass('color-black-modifier')
				$('.kunye-item-left').eq(indexTarget).addClass('color-black-modifier')

			})

			$('.kunye-item-left').on("mouseout", function () {
				$('.kunye-item-right').removeClass('color-black-modifier')
				$('.kunye-item-left').removeClass('color-black-modifier')

				console.log($(this).index())
			})

			$('.kunye-item-right').on("mouseover", function () {
				var indexTarget = $(this).index()
				// $('.kunye-item-right').addClass('color-black-modifier')
				$('.kunye-item-left').eq(indexTarget).addClass('color-black-modifier')
				$('.kunye-item-right').eq(indexTarget).addClass('color-black-modifier')

			})

			$('.kunye-item-right').on("mouseout", function () {
				$('.kunye-item-left').removeClass('color-black-modifier')
				$('.kunye-item-right').removeClass('color-black-modifier')

				console.log($(this).index())
			})


		}
	}
</script>

<style scoped>
	hr {
		color: black;
		border: none;
		border-left: 1px solid;
	}

	a {
		text-decoration: none;
	}

	.kunye-page {
		background-color: #b4b4b4;
		color: black;
		padding: 80px 60px;

	}

	.kunye-item {
		margin-bottom: 30px;
		color: #494949;
	}

	.kunye-item:hover {
		color: black;
	}

	.kunye-item-left {
		text-align: right;
	}

	.kunye-item-right {
		text-align: left;
	}

	#vert-rule {
		margin: 30px;
		margin-block-end: 0;
		margin-block-start: 0;
	}

	#vert-rule-2 {
		margin: 10px;
		margin-block-end: 0;
		margin-block-start: 0;
	}

	.vert-rule {
		margin: 10px;
		margin-block-end: 0;
		margin-block-start: 0;
	}

	.work-name {
		font-family: 'hk-grotesk-boldlegacy';
		font-size: 48px;

	}

	.work-name::first-letter {
		font-family: 'hk-grotesk-boldlegacy';

	}

	.work-name:hover::first-letter {
		font-family: 'gothicdawn';
		font-size: 55px;

	}

	.work-description:hover + .work-name::first-letter {
		font-family: 'gothicdawn';
		font-size: 55px;
	}


	.work-description {
		font-size: 24px;
		font-family: 'hk-grotesk-semibold';
	}


	.work-description:hover + .work-name::first-letter {
		font-size: 55px;
		font-family: 'gothicdawn';

	}

	.stream-link {
		position: absolute;
		right: 25px;
		top: 100px;
		color: red;

		display: flex;

		flex-direction: row;
		text-decoration: none;
		font-size: 20px;
	}

	.stream-link:hover {
		color: black;
	}

	.stream-link:hover .vert-rule {
		border-color: black !important;

	}


	.color-black-modifier {
		color: black;
		font-size: 55px;

	}

	.color-black-modifier > .work-name::first-letter {
		font-family: 'gothicdawn';
		font-size: 55px;

	}
</style>